import { render, staticRenderFns } from "./CPOColComparison.vue?vue&type=template&id=9c334bbc&scoped=true&"
import script from "./CPOColComparison.vue?vue&type=script&lang=js&"
export * from "./CPOColComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c334bbc",
  null
  
)

export default component.exports